import { queryOptions } from "@tanstack/react-query";
import { getBlogBlueprints as getBlogBlueprintsApi } from 'src/common/Scraper';
import { BlogGenerationResponse } from "../../types/blog-generation-agent.types";

/**
 * Generates the React Query options for fetching blog post blueprints.
 * 
 * This helper returns a query options configuration object used to retrieve
 * existing blog post blueprint runs from the scraper API for a specific user and site.
 * 
 * @param userId - The ID of the user requesting the blueprints.
 * @param siteId - The ID of the site for which the blueprints are generated.
 * @returns Query options configuration for React Query.
 */
function getBlogBlueprints(userId: string, siteId: string) {

    return queryOptions({
        queryKey: ['blog-blueprints', userId, siteId],
        queryFn: () => getBlogBlueprintsApi(userId, siteId) as Promise<BlogGenerationResponse>,
        enabled: !!userId && !!siteId
    });
}

export default getBlogBlueprints;
